import { getBalanceNumber } from './formatBalance'
import { IPricesContext } from '../contexts/PricesContext'

const getPriceFromAmountByPoolId = (farm, prices: IPricesContext): number => {
  if (!farm.userData) {
    return 0
  }

  const { userData, quoteTokenSymbol } = farm

  const amountValueByPoolId = getBalanceNumber(userData.lpTokenValue) / getBalanceNumber(userData.totalLPSupply)

  switch (quoteTokenSymbol) {
    case 'BUSD':
      return amountValueByPoolId * 2
    case 'BNB':
      return amountValueByPoolId * prices.bnb * 2
    case 'MMPRO':
      return amountValueByPoolId * prices.ourToken.toNumber() * 2
    default:
      return amountValueByPoolId * prices.eth * 2
  }
}

export default getPriceFromAmountByPoolId
